/*
 *
 * Home constants
 *
 */

export const DEFAULT_ACTION = "app/Administrator/Companies/Home/DEFAULT_ACTION"

export const GET_COMPANIES_WATCHER =
  "app/Administrator/Companies/Home/GET_COMPANIES_WATCHER"
export const GET_COMPANIES_SUCCESS =
  "app/Administrator/Companies/Home/GET_COMPANIES_SUCCESS"
export const GET_COMPANIES_FAILED =
  "app/Administrator/Companies/Home/GET_COMPANIES_FAILED"

export const GET_COMPANIES_INFO_WATCHER =
  "app/Administrator/Companies/Home/GET_COMPANIES_INFO_WATCHER"
export const GET_COMPANIES_INFO_SUCCESS =
  "app/Administrator/Companies/Home/GET_COMPANIES_INFO_SUCCESS"

export const SEARCH_WATCHER = "app/Administrator/Companies/Home/SEARCH_WATCHER"
export const SEARCH_SUCCESS = "app/Administrator/Companies/Home/SEARCH_SUCCESS"
export const SEARCH_FAILED = "app/Administrator/Companies/Home/SEARCH_FAILED"

export const GO_COMPANY_WATCHER =
  "app/Administrator/Companies/Home/GO_COMPANY_WATCHER"
